"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStoreStats = exports.getImportPercentage = exports.getImportStage = exports.getImportEndedAtTimestamp = exports.getImportStartedAtTimestamp = exports.getImportDetail = exports.getImportStatus = exports.getWorkflowIds = exports.getStoreDetails = exports.getStoresById = exports.getEcommerceV2State = exports.getFetchImportDetailsRequestStatus = exports.getStartImportRequestStatus = exports.getFetchStoreDetailsRequestStatus = exports.getFetchStatsRequestStatus = exports.getFetchStoresRequestStatus = void 0;

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("settings-ui-sdk/EcommerceV2/actions");

var getFetchStoresRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceV2ActionTypes.FETCH_STORES);
exports.getFetchStoresRequestStatus = getFetchStoresRequestStatus;
var getFetchStatsRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceV2ActionTypes.FETCH_STATS);
exports.getFetchStatsRequestStatus = getFetchStatsRequestStatus;
var getFetchStoreDetailsRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceV2ActionTypes.FETCH_STORE_DETAILS);
exports.getFetchStoreDetailsRequestStatus = getFetchStoreDetailsRequestStatus;
var getStartImportRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceV2ActionTypes.START_IMPORT);
exports.getStartImportRequestStatus = getStartImportRequestStatus;
var getFetchImportDetailsRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceV2ActionTypes.FETCH_IMPORT_DETAILS);
exports.getFetchImportDetailsRequestStatus = getFetchImportDetailsRequestStatus;

var getEcommerceV2State = function getEcommerceV2State(state) {
  return state.modules.ecommerce.ecommerceV2;
};

exports.getEcommerceV2State = getEcommerceV2State;
var getStoresById = (0, _reselect.createSelector)([getEcommerceV2State], function (state) {
  return state.get('stores');
});
exports.getStoresById = getStoresById;
var getStoreDetails = (0, _reselect.createSelector)([getEcommerceV2State], function (state) {
  return state.get('details');
});
exports.getStoreDetails = getStoreDetails;
var getWorkflowIds = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.get('workflows');
});
exports.getWorkflowIds = getWorkflowIds;
var getImportStatus = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.getIn(['import', 'status']);
});
exports.getImportStatus = getImportStatus;
var getImportDetail = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.getIn(['import', 'syncImportDetail']);
});
exports.getImportDetail = getImportDetail;
var getImportStartedAtTimestamp = (0, _reselect.createSelector)([getImportDetail], function (importDetail) {
  return importDetail && importDetail.importStartedAt;
});
exports.getImportStartedAtTimestamp = getImportStartedAtTimestamp;
var getImportEndedAtTimestamp = (0, _reselect.createSelector)([getImportDetail], function (importDetail) {
  return importDetail && importDetail.importEndedAt;
});
exports.getImportEndedAtTimestamp = getImportEndedAtTimestamp;
var getImportStage = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.getIn(['import', 'syncImportDetail']).stage;
});
exports.getImportStage = getImportStage;
var getImportPercentage = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.getIn(['import', 'syncImportDetail']).percentageComplete;
});
exports.getImportPercentage = getImportPercentage;
var getStoreStats = (0, _reselect.createSelector)([getStoreDetails], function (storeDetails) {
  return storeDetails.get('counts');
});
exports.getStoreStats = getStoreStats;